export interface UserDocument {
    id: string;
    fileName: string;
    fileType: 'cv' | 'linkedin' | 'additional';
    fileUrl?: string; // For uploaded files
    linkUrl?: string; // For LinkedIn profile link
    uploadedAt: Date;
    fileSize?: number; // in bytes
    mimeType?: string;
}

export interface DocumentUploadRequest {
    file?: File;
    linkUrl?: string;
    fileType: 'cv' | 'linkedin' | 'additional';
}

export interface DocumentUploadResponse {
    status: 'success' | 'error';
    message: string;
    document?: UserDocument;
}

export interface DocumentListResponse {
    status: 'success' | 'error';
    message: string;
    documents: UserDocument[];
}

export interface DeleteDocumentResponse {
    status: 'success' | 'error';
    message: string;
}

export const ALLOWED_FILE_TYPES = {
    cv: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    additional: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/jpeg', 'image/png']
};

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const FILE_TYPE_LABELS = {
    cv: 'CV/Resume',
    linkedin: 'LinkedIn Profile',
    additional: 'Additional Document'
};

// Profile Analysis Types
export interface ProfileAnalysis {
    id: string;
    userId: string;
    analysis: string;
    userHasDocuments: boolean;
    documentCount: {
        cv: number;
        linkedin: number;
        additional: number;
    };
    linkedinProvided: boolean;
    analysisTimestamp?: string;
    createdAt: string;
    isActive: boolean;
}

export interface ProfileAnalysisResponse {
    analysis: string;
    user_has_documents: boolean;
    document_count: {
        cv: number;
        linkedin: number;
        additional: number;
    };
    linkedin_provided: boolean;
    analysis_timestamp?: string;
    analysis_id?: string;
    status: 'success' | 'error';
    error?: string;
}

export interface ProfileAnalysesListResponse {
    analyses: ProfileAnalysis[];
    count: number;
    status: 'success' | 'error';
    error?: string;
}

export interface SingleProfileAnalysisResponse {
    analysis: ProfileAnalysis;
    status: 'success' | 'error';
    error?: string;
} 